import React, { Component, PureComponent } from 'react'
import { Map, List, fromJS } from 'immutable'
import Wysiwyg from './Wysiwyg'
import { Icon } from 'semantic-ui-react'

const langs = ['fi', 'en', 'se']

export default class TemplatesField extends PureComponent {
  state = {
    activeLang: 'fi',
  }

  render() {
    let { value, onChange, rawEdit = false, name } = this.props

    console.log(name, value)

    if (!Map.isMap(value)) value = Map()

    console.log(value.toJS())

    let { activeLang } = this.state

    return (
      <div className="field-item field-item--templates templates">
        <div className="templates-switcher">
          {langs.map(lang => {
            let classes = ['templates-switcher-item']
            if (lang === activeLang) classes.push('templates-switcher-item--active')

            let hasValue = value.get(lang, '').trim() !== '' && value.get(lang, '').trim() !== '<p><br></p>'
            if (hasValue) classes.push('templates-switcher-item--hasvalue')

            return (
              <button
                className={classes.join(' ')}
                key={lang}
                onClick={e => e.preventDefault() & this.setState({ activeLang: lang })}>
                <Icon name={hasValue ? 'check circle' : 'circle outline'} />
                <span>{lang}</span>
              </button>
            )
          })}
        </div>
        <div className="templates-item">
          {rawEdit ? (
            <textarea
              name={`${name}-${activeLang}`}
              value={value.get(activeLang, '')}
              onChange={e => onChange({ name, value: value.set(activeLang, e.target.value) })}
            />
          ) : (
            <Wysiwyg
              name={`${name}-${activeLang}`}
              value={value.get(activeLang, '')}
              emailTemplate
              onChange={({ value: langValue }) => onChange({ name, value: value.set(activeLang, langValue) })}
            />
          )}
        </div>
      </div>
    )
  }
}
